/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Link({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M12.525 3.474a2.4 2.4 0 0 0-3.394 0L7.717 4.89a.6.6 0 0 1-.848-.849l1.414-1.414a3.6 3.6 0 0 1 5.091 5.091L11.96 9.131a.6.6 0 0 1-.849-.848l1.414-1.414a2.4 2.4 0 0 0 0-3.395m-1.272 1.273a.6.6 0 0 1 0 .849l-5.657 5.657a.6.6 0 0 1-.849-.849l5.657-5.657a.6.6 0 0 1 .849 0M4.889 6.87a.6.6 0 0 1 0 .848L3.474 9.131a2.4 2.4 0 1 0 3.395 3.394l1.414-1.414a.6.6 0 0 1 .848.849l-1.414 1.414a3.6 3.6 0 1 1-5.091-5.091L4.04 6.869a.6.6 0 0 1 .849 0" clipRule="evenodd" /></svg>;
}
;